<template>
    <el-dialog
        :title="`日志(发车单号：${dispatchNo})`"
        :visible="true"
        width="82%"
        v-loading="loading"
        height="70vh"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        custom-class="dispatch-operationNode-LogDialog"
        :before-close="handleClose">
        <div class="grid-container">
            <div class="grid-item">
                <vxe-grid ref="orderGridRef" v-bind="orderOptions" @cell-click="clickOrderCell" @toggle-tree-expand="toggleTreeExpand">
                    <template #header_filter_orderNo>
                        <div class="filter-container">
                            <div class="filter-title">单号</div>
                            <el-divider class="filter-divider"></el-divider>
                            <el-input placeholder="请输入客户订单号/运单号" class="filter-input" v-model.trim="orderNo" @keyup.enter.native="filterOrderTable" clearable :disabled="disableOrderInput">
                                <el-button slot="append" icon="el-icon-search" @click="filterOrderTable" :disabled="disableOrderInput"></el-button>
                            </el-input>
                        </div>
                    </template>
                </vxe-grid>
            </div>
            <div class="grid-item">
                <vxe-grid ref="nodeGridRef" v-bind="nodeOptions" @cell-click="clickNodeCell"></vxe-grid>
            </div>
            <div class="grid-item">
                <vxe-grid v-bind="logOptions" @cell-dblclick="dblclickLogCell">
                    <template #imgUrl_default="{ row }">
                        <img v-if="row.picUrl && row.picUrl.length" src="@/assets/photos.png" @click.stop='handleImgClick(row)' style="width: 20px; cursor: pointer;">
                    </template>
                </vxe-grid>
            </div>
        </div>

        <performance-preview-file :imgArr="tableAttachmentList" :attachmentShow.sync="attachmentShow" v-if="attachmentShow"></performance-preview-file>
    </el-dialog>
</template>

<script>
import DM from './main.js';
export default { ...DM };
</script>

<style lang="less" scope>
@import './style.less';
</style>
